import { css } from '@landr/styled-system/css';

export const typeIconButton = css({
    _hover: {
        cursor: 'auto',
    },
});
